var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { mergeProps } from '@react-aria/utils';
import { useFocusRing } from '@react-aria/focus';
import { logError, setTitleCase } from '../helpers';
import { buttonStyle, innerContentStyle } from './styles';
import ButtonLoader from './loader';
import { MESSAGES } from './debug-messages';
function ButtonInternal(_a, ref) {
    var as = _a.as, _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, _g = _a.disableTitleCase, disableTitleCase = _g === void 0 ? false : _g, icon = _a.icon, iconLeft = _a.iconLeft, iconRight = _a.iconRight, children = _a.children, type = _a.type, ariaLabel = _a["aria-label"], restProps = __rest(_a, ["as", "variant", "size", "isLoading", "inverted", "fullWidth", "disableTitleCase", "icon", "iconLeft", "iconRight", "children", "type", 'aria-label']);
    // Log console.error when an empty string is passed as incorrect syntax
    if (typeof children === 'string' && children.length === 0) {
        logError(MESSAGES.EMPTY_CHILDREN);
    }
    var Element = as || 'button';
    var _h = useFocusRing(), focusProps = _h.focusProps, isFocusVisible = _h.isFocusVisible;
    function renderIcon(originalIcon, key) {
        // Check if the Icon has a provided custom size prop already
        return originalIcon.props.size
            ? originalIcon
            : cloneElement(originalIcon, {
                key: key,
                // Handle large buttons having medium sized Icons by default, and small / medium as defined
                size: size === 'large' ? 'medium' : size,
            });
    }
    return (_jsxs(Element, __assign({}, mergeProps(focusProps, restProps), (isLoading && {
        disabled: true,
    }), { type: !type && Element === 'button' ? 'button' : type, "aria-label": isLoading ? ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.concat(' ', 'Loading') : ariaLabel, ref: ref, css: buttonStyle({
            variant: variant,
            size: size,
            inverted: inverted,
            fullWidth: fullWidth,
            isIconOnly: !!icon,
            isLoading: isLoading,
            isFocusVisible: isFocusVisible,
        }) }, { children: [icon ? (renderIcon(icon, 'button-icon-only')) : (_jsxs("span", __assign({ css: innerContentStyle({
                    size: size,
                }) }, { children: [iconLeft && renderIcon(iconLeft, 'button-left-icon'), typeof children === 'string' && !disableTitleCase
                        ? setTitleCase(children)
                        : children, iconRight && renderIcon(iconRight, 'button-right-icon')] }))), isLoading && (_jsx(ButtonLoader, __assign({}, {
                size: size,
                variant: variant,
                inverted: inverted,
                isIconOnly: !!icon,
            }), "button-loader"))] })));
}
export default ButtonInternal;
